<ul class="icons-ul big-icons-ul">
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Bill icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine1' | translate }}
  </li>
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Edit icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine2' | translate }}
  </li>
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Applications icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine3' | translate }}
  </li>
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Calendar icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine4' | translate }}
  </li>
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Appointment icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine5' | translate }}
  </li>
  <li class="rs-padding-bottom3">
    <i class="icon-li icon-Freeservices icon-2x icon-lh" aria-hidden="true"></i
    >{{ 'bills.deferral.rules.listLine6' | translate }}
  </li>
</ul>
